var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"footer-border-blog"}),_c('p',{staticClass:"footer-title-blog"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" - PT Generasi Anak Muda Berkarya ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }